import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';

import Button from './Button';

export const VerifyButton = ({ onClick, isVerified, isLoading, className = '' }) => {
  const [isHovered, setIsHovered] = useState(false);
  const baseClasses = `${className} h-[calc(100%-6px)] w-28 absolute right-[3px] bottom-[3px]`;

  if (isLoading) {
    return (
      <Button
        label="Verifying..."
        modifier="primary"
        isLoading
        className={baseClasses}
      />
    );
  }

  if (isVerified) {
    return (
      <Button
        label={isHovered ? 'Undo' : 'Verified'}
        modifier="secondary"
        onClick={onClick}
        className={`${baseClasses} bg-green-500 hover:bg-green-600 text-white`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="flex items-center justify-center gap-2">
          <Check size={16} />
          <span>{isHovered ? 'Undo' : 'Verified'}</span>
        </div>
      </Button>
    );
  }

  return (
    <Button
      label="Verify"
      modifier="primary"
      onClick={onClick}
      className={baseClasses}
    />
  );
};

VerifyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isVerified: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

VerifyButton.defaultProps = {
  isVerified: false,
  isLoading: false,
  className: '',
};

export default VerifyButton;
